// extracted by mini-css-extract-plugin
export default {"shipLevelName":"ClassNationHistoryTable_shipLevelName_b7dac","shipLevel":"ClassNationHistoryTable_shipLevel_d45d6"};